import { render, staticRenderFns } from "./PlainRouterView.vue?vue&type=template&id=39a1207a&scoped=true&"
import script from "./PlainRouterView.vue?vue&type=script&lang=js&"
export * from "./PlainRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1207a",
  null
  
)

export default component.exports